import { useCallback, useState } from "react";
import { createAxiosInstance } from "../Axios/createAxiosInstance.ts";
import { AnalyticsParamsBag } from "./AnalyticsParamsBag.ts";
import { MoneyTransferInfoDTO } from "./MoneyTransferInfoDTO.ts";

export function useCreatePaymentIntent() {
  const [loading, setLoading] = useState(false);
  const createPaymentIntent = useCallback(
    async ({
      email,
      firstName,
      lastName,
      priceId,
      productId,
      utmContent,
      utmCampaign,
      utmTerm,
      utmSource,
      utmMedium,
    }: {
      email: string;
      firstName: string;
      lastName: string;
      priceId: string;
      productId: string;
    } & AnalyticsParamsBag) => {
      try {
        setLoading(true);
        const { data } = await createAxiosInstance().post<MoneyTransferInfoDTO>(
          `/payment-intent`,
          {
            email,
            firstName,
            lastName,
            priceId,
            productId,
            utmTerm,
            utmSource,
            utmMedium,
            utmContent,
            utmCampaign,
          },
        );

        return data;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    createPaymentIntent,
    loading,
  };
}
